import React from 'react';
import { BookOpen, Lightbulb } from 'lucide-react';
import { forms } from '../../data/forms'; // Soruları bulmak için ana veri kaynağını çağırıyoruz

export const BanaKendiniAnlatReportUI = ({ data, meta }) => {
  // SİHİRLİ DOKUNUŞ: Eski kayıtlarda risks boş kalmış olabilir diye veriyi doğrudan ham cevaplardan çekiyoruz!
  const rawAnswers = data.answers || meta?.answers || {};
  
  // AVAILABLE_TESTS yerine doğrudan 'forms' üzerinden arıyoruz (Sorular 'items' içinde yer alıyor)
  const testDef = forms.find(t => t.id === meta?.testId);
  
  const qAndA = [];
  Object.entries(rawAnswers).forEach(([qId, ansVal]) => {
      const qText = testDef?.items?.find(q => q.id === parseInt(qId))?.text || `Soru ${qId}`;
      if (ansVal && String(ansVal).trim() !== '') {
          qAndA.push({ question: qText, answer: String(ansVal) });
      }
  });

  return (
    <div className="space-y-6 print:space-y-4 font-sans flex flex-col print:min-h-[260mm]">
      {/* ÜST BAŞLIK */}
      <div className="bg-slate-900 text-white p-4 print:p-3 rounded-xl flex justify-between items-center shadow-sm print:bg-white print:text-black print:shadow-none print:border-b-2 print:border-slate-900">
        <div className="flex items-center gap-4 print:gap-3">
          <div className="h-12 w-12 print:h-9 print:w-9 rounded-xl flex items-center justify-center shadow-inner bg-blue-600 print:bg-slate-800">
            <BookOpen className="h-6 w-6 print:h-4 print:w-4 text-white"/>
          </div>
          <div>
            <h2 className="text-xl print:text-lg font-bold leading-none mb-1">Bana Kendini Anlat (Nitel Veri)</h2>
            <span className="text-[10px] print:text-[10px] text-slate-300 print:text-slate-600 font-bold tracking-widest uppercase block">
               {meta?.studentClass || "Sınıf Belirtilmemiş"} • ÖĞRENCİ NO: {meta?.studentNo || "-"}
            </span>
          </div>
        </div>
        <div className="bg-white/10 px-4 py-2 print:px-3 print:py-1.5 rounded-lg text-center print:border print:border-slate-300">
          <span className="text-2xl print:text-xl font-black block leading-none text-blue-300 print:text-blue-700">{qAndA.length}</span>
          <span className="text-[9px] print:text-[9px] block opacity-70 uppercase font-bold mt-0.5">Yanıt</span>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-2xl p-5 print:p-4 text-sm print:text-xs text-blue-800 leading-relaxed font-medium">
        <Lightbulb className="h-5 w-5 inline mr-2 text-blue-600 relative -top-0.5"/>
        Bu envanterde puanlama sistemi yoktur. Öğrencinin kendi kelimeleriyle ifade ettiği iç dünyasını anlamak için yanıtları dikkatlice okuyunuz ve en alttaki <strong>Yapay Zeka ile Yorumla</strong> butonunu kullanarak psikolojik bir profil çıkartınız.
      </div>

      {/* SORU - CEVAP KARTLARI */}
      <div className="space-y-4 print:space-y-3">
        {qAndA.length > 0 ? qAndA.map((item, index) => (
          <div key={index} className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden avoid-break print:border-slate-300">
            <div className="bg-slate-50 border-b border-slate-200 p-4 print:p-3">
              <h3 className="font-bold text-slate-700 text-sm print:text-xs flex items-start">
                <span className="bg-blue-100 text-blue-700 h-5 w-5 rounded flex items-center justify-center text-[10px] mr-2 shrink-0 mt-0.5">S{index+1}</span>
                {item.question}
              </h3>
            </div>
            <div className="p-5 print:p-4">
              <p className="text-slate-800 text-sm print:text-xs leading-relaxed whitespace-pre-wrap font-medium italic">
                "{item.answer}"
              </p>
            </div>
          </div>
        )) : (
          <p className="text-center text-slate-400 py-6">Öğrenci bu forma herhangi bir metin girmemiştir.</p>
        )}
      </div>
    </div>
  );
};